import styled from 'styled-components';

export const LandscapeErrorContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    background: ${(props) => props.theme.palette.primaryA7};
    padding: calc(50vh - 150px) 16px 0 16px;

    .access-container {
        &-title {
            margin-top: 8px;
            margin-bottom: 0;
        }

        &-text {
            max-width: 420px;
            margin: 0;
        }

        &-icon {
            width: 64px;
            height: 64px;
        }
    }
`;
